@let breakdown = pulseFeature.selectors.engagementBreakdown.asSignal();
@let items = itemsSg();
@let containerHeight = containerHeightSg();

@if (breakdown && items.length > 0 && containerHeight > 0) {
  <div class="atn-summit-pulse-breakdown">
    <div class="atn-summit-pulse-breakdown__left">
      <h3 class="atn-summit-pulse-breakdown__title">Breakdown</h3>
      <p class="atn-summit-pulse-breakdown__summary">
        {{ breakdown.summary }}
      </p>
    </div>

    <div
      class="atn-summit-pulse-breakdown__right"
      aria-hidden="false"
    >
      <div
        class="atn-summit-pulse-breakdown__circles"
        [style.height.px]="containerHeight"
        role="group"
        aria-label="Responsibility breakdown"
      >
        @for (item of items; track item.key) {
          <div
            class="atn-summit-pulse-breakdown__circle"
            [ngStyle]="item.styles"
          >
            <div class="atn-summit-pulse-breakdown__circle-inner">
              <div class="atn-summit-pulse-breakdown__circle-percent">
                {{ item.percent }}%
              </div>
              <div class="atn-summit-pulse-breakdown__circle-label">
                {{ item.label }}
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
